module.exports = __webpack_public_path__ + "static/media/kattohuopa-min.61da0315.jpg";